import { notifyDevtools } from '../../devtools';
export function performMulticall(provider, multicallExecutor, multicallAddress, blockNumber, uniqueCalls, dispatchState, chainId, reportError) {
  if (uniqueCalls.length === 0) {
    return;
  }
  var start = Date.now();
  multicallExecutor(provider, multicallAddress, blockNumber, uniqueCalls).then(function (state) {
    dispatchState({
      type: 'FETCH_SUCCESS',
      blockNumber: blockNumber,
      chainId: chainId,
      state: state
    });
    notifyDevtools({
      type: 'MULTICALL_SUCCESS',
      duration: Date.now() - start,
      chainId: chainId,
      blockNumber: blockNumber,
      multicallAddress: multicallAddress,
      state: state
    });
  }).catch(function (error) {
    reportError(error);
    dispatchState({
      type: 'FETCH_ERROR',
      blockNumber: blockNumber,
      chainId: chainId,
      error: error
    });
    notifyDevtools({
      type: 'MULTICALL_ERROR',
      duration: Date.now() - start,
      chainId: chainId,
      blockNumber: blockNumber,
      multicallAddress: multicallAddress,
      calls: uniqueCalls,
      error: error
    });
  });
}